module.exports = __webpack_public_path__ + "static/img/top12.8e10bad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top12.png
// module id = cNWO
// module chunks = 208